<template>
    <div class="ui translucent suimodal background-transparent" :class="{ small: !checkMobile, overlay: checkMobile, fullscreen: checkMobile }">
        <i class="close icon" />
        <div class="header">
            {{$t('profile.change_cover')}}
        </div>
        <div class="content">
            <div>
                <input style="display: none" ref="uploadAvatarInput" type="file" accept="image/*" @change="uploadAvatar">
                <div v-if="cover.src.length>0">
                    <div ref="imageContainer" class="container-header-cover" :style="coverStyle">
                        <button class="edit-cover" @click="openUploadDialog">
                            <i class="material-icons">edit</i>
                        </button>
                    </div>
                    <!--
                    <div class="sliders">
                        <div class="slider-container">
                            <label for="zoom">Zoom</label>
                            <input type="range" min="1" max="3" @input="changeSlide" step="0.1" v-model="cover.zoom">
                        </div>
                       <div class="slider-container">
                            <label for="rotation">Rotação</label>
                            <input type="range" min="-180" max="180" step="1" v-model="cover.rotation">
                        </div>
                    </div>-->
                </div>
                <div v-else>
                    <div class="field upload-area"
                         :class="{ dragging: isDragging }"
                         ref="upload-area"
                         @dragover.prevent="onDragOver"
                         @dragleave.prevent="onDragLeave"
                         @drop.prevent="onDrop"
                         @click="openUploadDialog">
                        <svg width="92" height="66" viewBox="0 0 92 66" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M21.9545 66C15.9606 66 10.803 63.8654 6.48182 59.5962C2.16061 55.3271 0 50.2316 0 44.3099C0 38.939 1.725 34.205 5.175 30.108C8.625 26.011 13.0682 23.5493 18.5045 22.723C19.8985 16.0438 23.1742 10.5869 28.3318 6.35211C33.4894 2.11737 39.4485 0 46.2091 0C54.0848 0 60.6886 2.80595 66.0205 8.41784C71.3523 14.0297 74.0182 20.7606 74.0182 28.6103V31.0892C79.0364 30.9515 83.2879 32.5524 86.7727 35.892C90.2576 39.2316 92 43.4491 92 48.5446C92 53.2958 90.2576 57.3928 86.7727 60.8357C83.2879 64.2786 79.1409 66 74.3318 66H49.1364C47.4636 66 46 65.3803 44.7455 64.1408C43.4909 62.9014 42.8636 61.4554 42.8636 59.8028V33.1549L34.1864 41.7277L29.6909 37.2864L46 21.1737L62.3091 37.2864L57.8136 41.7277L49.1364 33.1549V59.8028H74.3318C77.4682 59.8028 80.1515 58.7011 82.3818 56.4977C84.6121 54.2942 85.7273 51.6432 85.7273 48.5446C85.7273 45.446 84.6121 42.795 82.3818 40.5915C80.1515 38.3881 77.4682 37.2864 74.3318 37.2864H67.7455V28.6103C67.7455 22.482 65.6371 17.2144 61.4205 12.8075C57.2038 8.40063 51.9939 6.19718 45.7909 6.19718C39.5879 6.19718 34.3606 8.40063 30.1091 12.8075C25.8576 17.2144 23.7318 22.482 23.7318 28.6103H21.7455C17.4242 28.6103 13.7652 30.108 10.7682 33.1033C7.77121 36.0986 6.27273 39.7997 6.27273 44.2066C6.27273 48.4757 7.80359 52.1424 10.8653 55.2066C13.927 58.2707 17.6234 59.8028 21.9545 59.8028H36.5909V66H21.9545Z"
                                  fill="var(--buttons_color)"/>
                        </svg>
                        <h3>{{$t('profile.drag_drop')}}</h3>
                        {{$t('profile.or')}} <strong>{{$t('profile.click_here')}}</strong> {{$t('profile.to_search_files')}}
                    </div>
                </div>
            </div>
        </div>
        <div class="actions">
            <div class="ui deny button">
                {{$t('profile.cancelar')}}
            </div>
            <div class="ui positive button">
                {{$t('profile.confirm')}}
            </div>
        </div>
    </div>
</template>
<script>
import {mapGetters} from "vuex";
import axios from "axios";

// const emitter = require('tiny-emitter/instance')
export default {
    name: 'ChangeCoverModal',
    props: {
        userInformation: {
            type: Object,
            required: true
        },
        lmsSlug:{
            type: String,
            default: ""
        },
        userId:{
            type: Number,
            required: true
        },
    },
    data() {
        return {
            isDragging: false,
            isDraggingCover: false,
            cover: {
                url: this.userInformation.cover?.url??"",
                src: this.userInformation.cover?.url??"",
                position: {x: 0, y: 0},
                rotation: this.userInformation.cover?.rotation??0,
                zoom: this.userInformation.cover?.zoom??1,
                file: null
            },
        }
    },
    computed: {
        ...mapGetters([
            "checkMobile"
        ]),
        coverStyle() {
            return {
                backgroundImage: `url(${this.cover.src})`,
                backgroundSize: 'cover',
                backgroundPosition: `center center`,
            }
        }
    },
    mounted() {
        if(this.userInformation.cover?.position){
            this.cover.position ={
                x: Number(this.userInformation.cover.position.x),
                y: Number(this.userInformation.cover.position.y)
            }
        }
        window.$(this.$el).suimodal({
            closable: false,
            onApprove: () => {
                this.confirmSelection()
                return false;
            },
            onDeny: () => {
                // Implementar a lógica de cancelamento
            },
            onHidden: () => {
                this.$emit('close');
            }
        }).suimodal('show');
    },
    beforeDestroy() {
        window.$(this.$el).remove();
    },
    methods: {
        uploadAvatar(event) {
            const reader = new FileReader()
            reader.readAsDataURL(event.target.files[0])
            reader.onload = (e) => {
                this.cover.file = event.target.files[0]
                this.cover.src = e.target.result;
                this.cover.position = {x:0,y:0};
                this.cover.zoom = 1;
                this.cover.rotation = 0;
            }
        },
        confirmSelection() {
            let data = new FormData();
            if (this.cover.file)
                data.append('file', this.cover.file);
            data.append("position[x]", this.cover.position.x);
            data.append("position[y]", this.cover.position.y);
            data.append('rotation', this.cover.rotation);
            data.append('zoom', this.cover.zoom);
            data.append('url', this.cover.url);
            const vm = this;
            axios.post(this.$url_api + "api/user/cover", data, {headers: this.$app.headers,}).then(() => {
                window.$.toast({
                    class: 'success',
                    position: 'top right',
                    title: this.$t('notification.sucesso'),
                    showProgress: 'bottom',
                    displayTime: 6000,
                    showIcon: 'times',
                });
                vm.$store.dispatch('UserProfile/getUser', {slug: vm.lmsSlug, user_id: vm.userId}).then(() => {
                    vm.$app.wait(false)
                    vm.close()
                }).catch((error) => {
                    vm.$app.wait(false)
                    console.log(error)
                })
            }).catch((error) => {
                console.log(error);
                window.$.toast({
                    class: 'error',
                    position: 'top right',
                    title: this.$t('login.erro'),
                    message: this.$t('login.ocorreuUmErro'),
                    showProgress: 'bottom',
                    displayTime: 6000,
                    showIcon: 'times',
                });
            });
        },
        close() {
            window.$(this.$el).suimodal('hide');
        },
        onDragOver() {
            this.isDragging = true;
        },
        onDragLeave() {
            this.isDragging = false;
        },
        onDrop(event) {
            this.isDragging = false;
            let file = event.dataTransfer.files[0];
            const reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = (e) => {
                this.cover.file = file
                this.cover.src = e.target.result;
                this.cover.position = {x:0,y:0};
                this.cover.zoom = 1;
                this.cover.rotation = 0;
            }
        },
        openUploadDialog() {
            this.$refs.uploadAvatarInput.click();
        }
    }
}
</script>
<style scoped lang="scss">
.suimodal {
  padding: 54px 44px;

  .icon.close {
    top: 44px;
    right: 44px;
    color: #fff;
  }

  .ui.deny.button {
    background-color: transparent;
    color: #fff;
    border: none;
    padding: 12px 24px;
    font-size: 1rem;
    font-weight: 700;
    margin-right: 12px;
  }

  .upload-area {
    border-radius: 24px;
    border: 2px dashed rgba(255, 255, 255, 0.6);
    margin-top: 24px;
    padding: 48px;
    text-align: center;
    cursor: pointer;

    &.dragging {
      border-color: var(--buttons_color);
    }
  }

  .ui.positive.button {
    background-color: var(--buttons_color);
    color: var(--fonts_color);
    border: none;
    padding: 12px 24px;
    font-size: 1rem;
    font-weight: 700;

    &.red {
      background-color: #db2828;
      color: #fff;
    }
  }
  .container-header-cover{
    position: relative;
    height: 135px;
    width: 100%;
  }
  .sliders{
    display: flex;
    .slider-container{
      margin-top: 1rem;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      border: 1px solid rgba(255, 255, 255, 0.6);
      background: rgba(255, 255, 255, 0.1);
      padding: 18px 24px;
      border-radius: 7px;

      label{
        color: #fff;
        font-size: 1rem;
        font-weight: 700;
        margin-bottom: 0.5rem;
      }
      input{
        width: 100%;
        height: .5rem;
        background: rgba(255, 255, 255, 0.1);
        border: none;
        outline: none;
        -webkit-appearance: none;
        appearance: none;
        &::-webkit-slider-thumb{
          -webkit-appearance: none;
          appearance: none;
          width: 1rem;
          height: 1rem;
          background: var(--buttons_color);
          border-radius: 50%;
          cursor: pointer;
        }

        &::-moz-range-thumb{
          width: 1rem;
          height: 1rem;
          background: var(--buttons_color);
          border-radius: 50%;
          cursor: pointer;
        }
        &::-moz-range-progress{
          background: var(--buttons_color);
        }
      }

    }
  }
  .edit-cover{
    position: absolute;
    right: 1rem;
    top: 1rem;
    box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.1);
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    border: none;
    padding: 0.5rem;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    i{
      font-size: 1.5rem;
    }

  }
}

@media only screen and (max-width: 767.98px) {
  .ui.overlay.fullscreen.suimodal > .content.content.content {
    min-height: calc(100vh - 20rem);
  }
}
</style>